import { Card, CardBody, CardHeader, CardHeading } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EventAnalyticsOverviewResource } from "./analyticsTypes";

interface Props {
	overview: EventAnalyticsOverviewResource;
}

export const OverviewCard: FC<Props> = ({ overview }) => {
	const { t } = useTranslation();

	return (
		<Card>
			<CardHeader>
				<CardHeading>{t("Overview")}</CardHeading>
			</CardHeader>
			<CardBody>
				<div>
					{t("Total events")}: {overview.total}
				</div>
				<div>
					{t("Planned events")}: {overview.planned}
				</div>
				<div>
					{t("Past events")}: {overview.past}
				</div>
			</CardBody>
		</Card>
	);
};
